import MaterialButton from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';

export const buttonSizeEnum = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

const Button = ({ onClick, disabled, type, children, primary, classes, size, ...materialProps }) => (
  <MaterialButton
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...materialProps}
    size={size}
    variant={primary ? 'contained' : 'outlined'}
    color="primary"
    onClick={onClick}
    disabled={disabled}
    type={type}
    classes={classes}>
    {children}
  </MaterialButton>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape(),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  type: PropTypes.string,
  size: PropTypes.string,
};

Button.defaultProps = {
  classes: undefined,
  disabled: false,
  onClick: () => undefined,
  primary: false,
  type: 'button',
  size: buttonSizeEnum.medium,
};

export default React.memo(Button);
